import FileField from './FileField'
import Employee from './Employee'
export class SaveFileFieldRequest {
    FileField: FileField;
    SavedByEmployee: Employee;
}

export default SaveFileFieldRequest;